import React, { Component } from 'react'
import { object, node } from 'prop-types'

import Slick from 'react-slick'
import './Slider.scss'

class Slider extends Component {
  static defaultProps = {
    settings: {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    children: null,
  }

  static propTypes = {
    settings: object,
    children: node,
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.slicks) {
        this.slicks.innerSlider.onWindowResized()
      }
    }, 1500)
  }

  render() {
    const { settings, children } = this.props

    return (
      <div className='slick__wrapper'>
        <Slick ref={(e) => { this.slicks = e }} {...settings}>
          {children}
        </Slick>
      </div>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/common/Slider/Slider.js